import { render, staticRenderFns } from "./InvoicesActionButtons.vue?vue&type=template&id=0bff098e&scoped=true"
import script from "./InvoicesActionButtons.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicesActionButtons.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicesActionButtons.vue?vue&type=style&index=0&id=0bff098e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bff098e",
  null
  
)

export default component.exports